import React from 'react';
import ReactDOM from 'react-dom/client';
import 'antd/dist/reset.css';
import "leaflet/dist/leaflet.css";
import './index.css';
import './odometer-theme-car.css';
import App from './App';
import {ConfigProvider} from "antd";
import moment from 'moment';
import {RouterProvider} from "react-router-dom";
import {routes} from "./components/Routes";
import {Provider} from "react-redux";
import stores from "./stores";
import tr_TR from "antd/lib/locale/tr_TR";

moment.locale("tr");

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <ConfigProvider locale={tr_TR}>
        <Provider store={stores}>
            <RouterProvider router={routes}>
                <App/>
            </RouterProvider>
        </Provider>
    </ConfigProvider>
);
